import { Cake, User, Phone, type LucideIcon } from "lucide-react";
import cn from "@/lib/cn";
import { formatDate } from "@/lib/time";
import { Patient } from "@/components/data";

interface MetaItemProps {
  icon: LucideIcon;
  children: React.ReactNode;
  className?: string;
}

function MetaItem({ icon: Icon, children, className }: MetaItemProps) {
  return (
    <span className={cn("inline-flex items-center gap-[3px]", className)}>
      <Icon className="size-3 text-[#9CA3AF]" strokeWidth={1.8} />
      {children}
    </span>
  );
}

interface PatientMetaProps {
  patient: Pick<Patient, "dob" | "mrn" | "phone">;
}

export function PatientMeta({ patient }: PatientMetaProps) {
  return (
    <span className="flex items-center gap-2 text-xs font-medium text-[#6B7280]">
      {patient.dob && <MetaItem icon={Cake}>{formatDate(patient.dob)}</MetaItem>}
      <MetaItem icon={User} className="tabular-nums">
        {patient.mrn}
      </MetaItem>
      <MetaItem icon={Phone}>{patient.phone}</MetaItem>
    </span>
  );
}
